"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ssoRegisterPath = exports.CREATE_NEW_LIST_BUTTON = exports.ANONYMOUS_CONTENT = exports.ADD_TO_OR_REMOVE_FROM_LIST_CONTENT = void 0;
const ssoRegisterPath = exports.ssoRegisterPath = '/ssoidentity/register';
const ADD_TO_OR_REMOVE_FROM_LIST_CONTENT = exports.ADD_TO_OR_REMOVE_FROM_LIST_CONTENT = 'add-to-or-remove-fromlist-content';
const ANONYMOUS_CONTENT = exports.ANONYMOUS_CONTENT = 'anonymous-content';
const CREATE_NEW_LIST_BUTTON = exports.CREATE_NEW_LIST_BUTTON = 'create-new-list-button';
